export const DatepickerMonths: string[] = [
    "datepicker.month.january",
    "datepicker.month.february",
    "datepicker.month.march",
    "datepicker.month.april",
    "datepicker.month.may",
    "datepicker.month.june",
    "datepicker.month.july",
    "datepicker.month.august",
    "datepicker.month.september",
    "datepicker.month.october",
    "datepicker.month.november",
    "datepicker.month.december",

];

export const DatepickerDays: string[] = [
    "datepicker.weekday.monday",
    "datepicker.weekday.tuesday",
    "datepicker.weekday.wednesday",
    "datepicker.weekday.thursday",
    "datepicker.weekday.friday",
    "datepicker.weekday.saturday",
    "datepicker.weekday.sunday",
];


export interface DatepickerContext {
    calendarEl: HTMLDivElement;
    datePickerEl: HTMLElement;
    internalInputEl: HTMLInputElement;
    externalInputEl: HTMLInputElement;
    statusEl: HTMLDivElement;
    firstYearChunkEl: HTMLDivElement;
    calendarDate: HTMLDivElement;
    minDate: Date;
    maxDate: Date;
    selectedDate: Date;
    rangeDate: Date;
    defaultDate: Date;
}

export interface DatepickerDayString {
    weekday?: string;
    day?: number;
    month?: string;
    year?: number;
}
export interface DatepickerDay {
    day: number;
    month: number;
    year: number;
    value: Date;
    label: DatepickerDayString;
    selected: boolean;
    disabled: boolean;
    focused: boolean;
}


export interface DatepickerYearOrMonth {
    value: number;
    selected: boolean;
    disabled: boolean;
    label: string;
}